export const DisputeStatus = ['Waiting', 'Appealable', 'Solved']
